// Module
var code = `<ex-multi-occurrence-analyse multi-occurrence-out="vm.multiOccurrence" multi-occurrence-options="vm.multiOccurrenceOptions"> </ex-multi-occurrence-analyse>`;
// Exports
module.exports = code;